module.exports = __webpack_public_path__ + "img/symbol_12.351d3af0.png";